'use client'

import { Dialog, DialogContent } from '@qr-front/ui/components/Dialog'
import { useAtom } from 'jotai'
import { useTranslations } from 'next-intl'

import { PHONE_PREVIEW_OVERLAY_SLOT_ID } from '../../../../components/PhonePreview'
import { isPreviewDialogOpenAtom } from '../../generatorState'
import { GeneratorPreview } from '../GeneratorPreview'

export const PreviewDialog = () => {
	const t = useTranslations()
	const [isOpen, setIsOpen] = useAtom(isPreviewDialogOpenAtom)

	const handleInteractOutside: Parameters<
		typeof DialogContent
	>[0]['onInteractOutside'] = (event) => {
		const isQrOverlayOpen =
			event.target instanceof Node &&
			document
				.getElementById(PHONE_PREVIEW_OVERLAY_SLOT_ID)
				?.contains(event.target)

		if (isQrOverlayOpen) {
			event.preventDefault()
		}
	}

	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogContent
				closeButtonLabel={t('ui__popup__close_button')}
				usePortal={false}
				onInteractOutside={handleInteractOutside}
				className="mt-3 py-6 tablet:mt-1 desktop:mt-0"
			>
				<GeneratorPreview absolutelyPositionedSwitch={false} scaleDown />
			</DialogContent>
		</Dialog>
	)
}
